// CUSTOMER IMPORTS
import CustomerSignUpPage from "./components/CustomerSignUpPage";
import CustomerSearch from "./components/Customersearch";
import HomePage from "./components/HomePage";
import VendorListing from "./components/VendorListing";
import ProductSummary from "./components/ProductSummary";
import CustomerLogInPage from "./components/CustomerLogInPage";
import customerCartPage from "./components/customerCartPage";
import customerConfirmationPage from "./components/customerConfirmationPage";
import accountPageServicing from "./components/accountPageServicing";
import headerServicing from "./components/serviicngHeader";
import custSerRefferalPage from "./components/custSerRefferalPage";
import custSerOffers from "./components/custSerOffers";
import customer_image_cropperjs from "./components/customer_image_cropper";
import header from "./components/headerpart";
import GoogleMapsApi from "./helpers/GoogleMapsApi";
import productListing from "./components/productListing";
import customer_all_offers from "./components/customer_all_offers";
import Wall from "./components/wall";
import CartObject from "./helpers/cartUtil";
import Util from "./helpers/util";
import trixUtil from "./helpers/trixUtil";
import customerQuoteRequests from "./components/customerQuoteRequests";

// ─── Trix toolbar setup ───────────────────────────────────────────────────────
const trixObject = new trixUtil();
trixObject.trixCustomToolBar();

// ─── Shared helpers ───────────────────────────────────────────────────────────
const UtilObject = new Util();
const GoogleMapsObject = new GoogleMapsApi();
// Using shared singleton instance

class CustomerApp {
  headerFunctions = null;
  homepageFunctions = null;
  cartFunctions = null;
  vendorListingPageFunctions = null;

  constructor() {
    this.init();
  }

  async init() {
    console.log("Locaso: CustomerApp init started");
    this._setGlobals();
    await UtilObject.preloadCookies();
    this._initQuoteComponents();
    this._initAddressEventListeners();

    // Safeguard for Google Maps race condition (async/defer script)
    console.log("Locaso: Waiting for Google Maps...");
    const isGoogleReady = await new Promise((resolve) => {
      let retries = 0;
      const check = () => {
        if (typeof google !== "undefined" && google.maps) {
            console.log("Locaso: Google Maps is ready");
            resolve(true);
        }
        else if (retries++ > 50) { // Increased to 10 seconds (50 * 200ms)
            console.warn("Locaso: Google Maps timeout");
            resolve(false);
        }
        else setTimeout(check, 200);
      };
      check();
    });

    try {
      if (isGoogleReady) {
        const isOnHomePage = $(".homePage").length > 0;
        console.log("Locaso: Running initial location check. isOnHomePage:", isOnHomePage);
        await this.getCurrentAddress(false); // Silent: only use cache or IP guess
      } else {
        console.warn("Locaso: Google Maps API not loaded. Skipping location detection.");
      }
    } catch (err) {
      console.error("Locaso: Location detection error:", err);
    }

    this._initCustomerComponents();
    this._initCardNavigation();
    this.visitorCount();
    this.maintainCustomerFlow();
    console.log("Locaso: CustomerApp initialized completely");
  }

  _initCardNavigation() {
    $(document)
      .off("click.locasoCardNav")
      .on("click.locasoCardNav", ".near-you-vendor-card-modern, .product-card-modern", function (e) {
        if ($(e.target).closest("a, button, input, select, textarea, label").length) return;
        const href = $(this).find("a[href]").first().attr("href");
        if (!href || href === "#") return;
        window.location.href = href;
      });
  }

  _setGlobals() {
    globalThis.X_API_KEY = window.CONFIG?.X_API_KEY || "KFvDq77oq74WjKXKon4AIzaSyBzKejuO2tJjzKJ";
    const rawBaseURL = document.getElementsByClassName("baseURL")[0]?.value || window.location.origin + "/";
    globalThis.baseURL = rawBaseURL.endsWith("/") ? rawBaseURL : rawBaseURL + "/";
    
    globalThis.LAT = localStorage.getItem('locaso_LAT') || null;
    globalThis.LNG = localStorage.getItem('locaso_LNG') || null;
    globalThis.BUFFER = 100;
    globalThis.addressDetails = {};
    globalThis.customerID = null;
    globalThis.orderID = null;
    globalThis.cropperMain = null;
    globalThis.orderDetalisMain = false;
    globalThis.cropperC = "";
  }

  _initCustomerComponents() {
    const has = (selector) => $(selector).length > 0;
    if (has(".header")) {
      this.headerFunctions = new header();
      this.headerFunctions.onDeleteSuccess = () => {
        const { CUSTOMER_ID } = UtilObject.getAllCookies();
        if (CUSTOMER_ID) sessionStorage.removeItem(`locaso:cache:addresses:${CUSTOMER_ID}`);
        this.customerHeaderAddressShow(true);
      };
    }
    if (has(".headerServicing")) new headerServicing();
    if (has(".homePage")) this.homepageFunctions = new HomePage();
    if (has(".search")) new CustomerSearch();
    if (has(".CustomerSignUpPage")) new CustomerSignUpPage();
    if (has(".CustomerLogInPage")) new CustomerLogInPage();
    if (has(".vendorListingPage")) this.vendorListingPageFunctions = new VendorListing();
    if (has(".ProductListingPage")) new productListing();
    if (has(".productSummaryPage")) new ProductSummary();
    if (has(".cartPage")) this.cartFunctions = new customerCartPage();
    if (has(".customerConfirmationPage")) new customerConfirmationPage();
    if (has(".customerServicingAccountPage")) {
      new accountPageServicing();
      new customer_image_cropperjs();
    }
    if (has(".allOffers")) new customer_all_offers();
    if (has("#wall-feed")) new Wall();
  }

  _initQuoteComponents() {
    new customerQuoteRequests();
    const handleQuoteClick = (e) => {
      e.preventDefault();
      const { CUSTOMER_ID } = UtilObject.getAllCookies();
      if (!CUSTOMER_ID) {
        const el = document.getElementById("createQuoteRequestModal");
        if (el) new bootstrap.Modal(el).show();
        return;
      }
      $.ajax({
        url: globalThis.baseURL + "api/customer/CustomerQuote/checkExistingQuote",
        type: "POST",
        data: { Customer_ID: CUSTOMER_ID },
        headers: { Authorization: globalThis.X_API_KEY },
        success: (res) => {
          if (res?.hasQuote) window.location.href = globalThis.baseURL + "customer/account?section=quote-requests";
          else {
            const el = document.getElementById("createQuoteRequestModal");
            if (el) new bootstrap.Modal(el).show();
          }
        }
      });
    };
    $(".locaso-post-quote-action, .locaso-post-quote-action-mobile").on("click", handleQuoteClick);
  }

  _initAddressEventListeners() {
    this.customerHeaderAddressShow(false);
    $(".submitBtnNavTop, .accountAdressEditButtonTop").on("click", () => {
      this.cartFunctions?.getAddressDetailsOnload();
      this.customerHeaderAddressShow(true);
    });

    // Swiggy-style auto-detect location
    $(document).on("click", ".useCurrentLocationNavTop", (e) => {
        console.log("Locaso: Detect location button clicked");
        this.detectLocation(e);
    });
  }

  detectLocation = async (e) => {
      const $btn = $(e.currentTarget);
      const originalHtml = $btn.html();
      $btn.html('<i class="fa-solid fa-spinner fa-spin me-2"></i>Detecting...');
      $btn.prop('disabled', true);

      try {
          console.log("Locaso: Calling navigatorGeolocationForCurrentLocation");
          const details = await GoogleMapsObject.navigatorGeolocationForCurrentLocation();
          console.log("Locaso: Detection result:", details);

          if (details) {
              const lat = details.lat;
              const lng = details.lng;
              
              UtilObject.createCookie("LAT", lat);
              UtilObject.createCookie("LNG", lng);
              globalThis.LAT = lat;
              globalThis.LNG = lng;

              const result = details.ROOFTOP || details.GEOMETRIC_CENTER || details.APPROXIMATE;
              let displayAddress = details.msgCode === 1 ? "Detected Location" : "Goa (Default)";
              if (result && result.address_components) {
                  const locality = result.address_components.find(c => c.types.includes("locality"))?.long_name;
                  const sublocality = result.address_components.find(c => c.types.includes("sublocality_level_1"))?.long_name;
                  displayAddress = sublocality && locality ? `${sublocality}, ${locality}` : (locality || sublocality || "Goa");
              }
              console.log("Locaso: Setting pill text to:", displayAddress);
              $(".currentAddress").text(displayAddress);

              // Close modal
              const modalEl = document.getElementById("exampleModalToggle");
              if (modalEl) {
                  if (window.bootstrap) {
                      bootstrap.Modal.getOrCreateInstance(modalEl).hide();
                  } else {
                      $(modalEl).modal("hide");
                  }
              }

              this.refreshFrames();
          } else {
              throw new Error("Location detection failed");
          }
      } catch (err) {
          console.error("Locaso: Detection failed", err);
          alert("Could not detect location. Please check your browser permissions.");
      } finally {
          $btn.html(originalHtml);
          $btn.prop('disabled', false);
      }
  }

  customerHeaderAddressShow(forceRefresh = false) {
    const { CUSTOMER_ID } = UtilObject.getAllCookies();
    if (!CUSTOMER_ID) return;
    UtilObject.getAddresses(CUSTOMER_ID, (result) => {
      this.renderCustomerAddresses(result);

      const selected = result.find(a => a.IsSelected == "1" || a.IsSelected == 1);
      const pillText = $(".currentAddress").text().trim();
      if (selected && (pillText === "Goa" || pillText === "Address Details")) {
          console.log("Locaso: Syncing pill with selected address:", selected.Address_Name);
          $(".currentAddress").text(selected.Address_Name);
          globalThis.LAT = selected.lat;
          globalThis.LNG = selected.lon;
          UtilObject.createCookie("LAT", selected.lat);
          UtilObject.createCookie("LNG", selected.lon);
      }
    }, forceRefresh);
  }

  renderCustomerAddresses(addresses) {
    let $container = $(".saved-address-container");
    if ($container.length === 0) $container = $(".saved-addresses");
    if ($container.length === 0) return;

    $container.empty();
    if (addresses && addresses.length > 0) {
        $container.append(`
            <div class="row mb-3">
                <div class="col text-start">
                    <h6 class="fw-bold text-uppercase small text-muted mb-0">Saved Addresses</h6>
                    <hr class="dropdown-divider">
                </div>
            </div>
        `);

        addresses.forEach(element => {
            $container.append(`
                <div class="row navTopAddress mb-2 mx-0 rounded-3 hover-bg-light p-2 border-bottom updateLocationAction" 
                     style="cursor: pointer; transition: background 0.2s;"
                     data-display-address="${element.Address_Name}" 
                     data-lat="${element.lat}" 
                     data-lng="${element.lon}">
                    <div class="col-12">
                        <div class="d-flex align-items-start gap-3">
                            <div class="flex-shrink-0 mt-1">
                                <i class="fa-solid fa-house-chimney" style="color: #ff385c; font-size: 1.2rem; width: 24px; text-align: center;"></i>
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                                <div class="fw-bold text-dark text-truncate" style="font-size: 1rem;">${element.Address_Name}</div>
                                <div class="small text-muted text-truncate">
                                    ${element.Address_Line_1 ? element.Address_Line_1 + ', ' : ''}${element.City || ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        });
    } else {
        $container.append(`
            <div class="py-4 text-center">
                <i class="fa-solid fa-location-dot mb-3 text-muted" style="font-size: 2rem; opacity: 0.3;"></i>
                <p class="text-muted mb-0">No saved addresses found</p>
            </div>
        `);
    }

    $(".updateLocationAction").off("click").on("click", (e) => {
        const $el = $(e.currentTarget);
        this.updateLocation({ currentTarget: $el[0] });
    });
  }

  updateLocation = async (event) => {
    const $target = $(event.currentTarget);
    const lat = parseFloat($target.data("lat"));
    const lng = parseFloat($target.data("lng"));
    const addressName = $target.data("display-address");

    UtilObject.createCookie("LAT", lat);
    UtilObject.createCookie("LNG", lng);
    globalThis.LAT = lat;
    globalThis.LNG = lng;

    if (addressName) $(".currentAddress").text(addressName);

    const modalEl = document.getElementById("exampleModalToggle");
    if (modalEl) {
        if (window.bootstrap) bootstrap.Modal.getOrCreateInstance(modalEl).hide();
        else $(modalEl).modal("hide");
    }

    this.refreshFrames();
  };

  refreshFrames() {
    if (this.homepageFunctions) {
      this.homepageFunctions.resetSectionResults();
      this.homepageFunctions.getOffers();
      this.homepageFunctions.getVendorByRating();
      this.homepageFunctions.getProductByRating?.();
      this.homepageFunctions.getCategories();
    }
  }

  async getCurrentAddress(force = false) {
    const cookies = UtilObject.getAllCookies();
    const $pillElements = $(".currentAddress");
    let currentPillText = "";
    let isGeneric = false;

    $pillElements.each(function() {
        const txt = $(this).text().trim();
        if (["Address Details", "Goa", "Location", "Address"].includes(txt)) {
            isGeneric = true;
            currentPillText = txt;
            return false;
        }
    });

    if (!isGeneric && $pillElements.length > 0) {
        currentPillText = $pillElements.first().text().trim();
    }

    console.log("Locaso: getCurrentAddress check. force:", force, "isGeneric:", isGeneric, "pillText:", currentPillText, "cookies.LAT:", cookies.LAT);

    // If we have a cookie and it's not a generic name, we are good, provided it's in Goa.
    if (cookies.LAT && !force) {
        const lat = parseFloat(cookies.LAT);
        const lng = parseFloat(cookies.LNG);
        const isNearGoa = lat > 14.5 && lat < 16.5 && lng > 73.0 && lng < 75.0;
        
        if (isNearGoa) {
            console.log("Locaso: Using existing valid Goa location from cookies");
            globalThis.LAT = cookies.LAT;
            globalThis.LNG = cookies.LNG;
            
            if (isGeneric) {
                console.log("Locaso: Pill is generic, fetching address name...");
                this._reverseGeocodeAndUpdatePill(lat, lng);
            }
            return;
        }
        console.warn("Locaso: Cookie location is outside Goa bounds (" + lat + "). Attempting re-detection.");
    }

    // Try to get precise location if already granted (no popup)
    if (navigator.permissions && !force) {
        try {
            const status = await navigator.permissions.query({ name: 'geolocation' });
            if (status.state === 'granted') {
                const details = await GoogleMapsObject.navigatorGeolocationForCurrentLocation();
                if (details && details.msgCode === 1) {
                    console.log("Locaso: Auto-detected precise location.");
                    this._applyLocationDetails(details);
                    return;
                }
            }
        } catch(e) {}
    }

    // Fallback/Initial: IP-based guess with Goa-Context validation
    if (!cookies.LAT || force) {
        console.log("Locaso: Attempting server-side IP detection...");
        try {
            const response = await fetch(globalThis.baseURL + 'api/customer/Location/detect', {
                headers: { 'Authorization': globalThis.X_API_KEY }
            });
            const data = await response.json();
            
            if (data.status === 'success' && data.lat && data.lon) {
                // Goa bounding box check (approx)
                const isNearGoa = data.lat > 14.5 && data.lat < 16.5 && data.lon > 73.0 && data.lon < 75.0;
                
                if (isNearGoa) {
                    console.log("Locaso: IP-based location valid (Near Goa):", data.city);
                    this._applyLocationDetails({ 
                        lat: data.lat, 
                        lng: data.lon, 
                        city: data.city || "Nearby" 
                    });
                    return;
                } else {
                    console.warn("Locaso: IP detection returned location outside Goa (" + data.city + "). Defaulting to Goa Center.");
                    // Default to Panaji, Goa
                    this._applyLocationDetails({ lat: 15.4909, lng: 73.8278, city: "Goa" });
                    return;
                }
            }
        } catch (e) {
            console.warn("Locaso: IP Geolocation failed.");
        }

        // Final last-resort fallback for Goa-centric experience
        if (!force) {
            console.log("Locaso: Defaulting to Goa Center (Panaji).");
            this._applyLocationDetails({ lat: 15.4909, lng: 73.8278, city: "Goa" });
        } else {
            console.log("Locaso: Force triggering browser geolocation prompt...");
            const details = await GoogleMapsObject.navigatorGeolocationForCurrentLocation();
            if (details) this._applyLocationDetails(details);
        }
    }
  }

  _applyLocationDetails(details) {
    const lat = details.lat;
    const lng = details.lng;
    let displayAddress = details.city || "Goa";

    if (details.ROOFTOP || details.GEOMETRIC_CENTER || details.APPROXIMATE) {
        const result = details.ROOFTOP || details.GEOMETRIC_CENTER || details.APPROXIMATE;
        const locality = result.address_components?.find(c => c.types.includes("locality"))?.long_name;
        const sublocality = result.address_components?.find(c => c.types.includes("sublocality_level_1"))?.long_name;
        displayAddress = sublocality && locality ? `${sublocality}, ${locality}` : (locality || sublocality || displayAddress);
    }

    console.log("Locaso: Setting location to:", displayAddress, lat, lng);
    
    globalThis.LAT = lat;
    globalThis.LNG = lng;
    UtilObject.createCookie("LAT", lat);
    UtilObject.createCookie("LNG", lng);
    localStorage.setItem('locaso_LAT', lat);
    localStorage.setItem('locaso_LNG', lng);
    
    $(".currentAddress").text(displayAddress);
    this.refreshFrames();
  }

  async _reverseGeocodeAndUpdatePill(lat, lng) {
    try {
        const details = await GoogleMapsObject.geocodeFindPosition(lat, lng);
        if (details && details.msgCode === 1) {
            const result = details.ROOFTOP || details.GEOMETRIC_CENTER || details.APPROXIMATE;
            const locality = result.address_components?.find(c => c.types.includes("locality"))?.long_name;
            const sublocality = result.address_components?.find(c => c.types.includes("sublocality_level_1"))?.long_name;
            const displayAddress = sublocality && locality ? `${sublocality}, ${locality}` : (locality || sublocality || "Goa");
            console.log("Locaso: Reverse geocode success. Setting pill to:", displayAddress);
            $(".currentAddress").text(displayAddress);
        }
    } catch(e) {
        console.warn("Locaso: _reverseGeocodeAndUpdatePill failed", e);
    }
  }

  maintainCustomerFlow() {
    const loc = window.location.href;
    if (!loc.includes("login") && !loc.includes("signup")) UtilObject.createCookie("PREVIOUS_PAGE", loc);
  }

  visitorCount() {
    const throttleKey = "locaso:visitor:customer:lastHitAt";
    const throttleMs = 30000;
    const lastHitAt = Number.parseInt(sessionStorage.getItem(throttleKey) || "0", 10);
    if (Date.now() - lastHitAt < throttleMs) return;
    sessionStorage.setItem(throttleKey, String(Date.now()));

    $.ajax({
      type: "POST",
      url: globalThis.baseURL + "api/visitor/updateVisitorCount",
      data: { type: "visit", section: "CUSTOMER" },
      headers: { Authorization: globalThis.X_API_KEY }
    });
  }
}

$(document).ready(() => { 
  try {
    new CustomerApp(); 
  } catch(e) {
    console.error("Locaso: CustomerApp CRASH", e);
  }
});
